<template>
  <div class="user-box">
    <ul class="select-option">
      <li v-if="checkPermission('sys:dept:save', permList)">
        <el-button
          type="primary"
          icon="iconfont icon-plus"
          @click.stop="add"
        >增加</el-button>
      </li>
      <li v-if="checkPermission('sys:dept:update', permList)">
        <el-button
          type="primary"
          icon="iconfont icon-xiugai"
          @click.stop="revise"
        >修改</el-button>
      </li>
      <li v-if="checkPermission('sys:dept:delete', permList)">
        <el-button
          type="primary"
          icon="iconfont icon-delet"
          @click.stop="del"
        >删除</el-button>
      </li>
    </ul>

    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      tooltip-effect="dark"
      style="width: 100%"
      row-key="deptId"
      :row-style="rowStyle"
      :row-class-name="rowClassName"
      @selection-change="selectionChange"
      @row-click="rowClick"
    >
      <el-table-column type="selection" width="100" align="center" />
      <el-table-column prop="name" label="部门名称" width="300" />
      <el-table-column label="部分ID" prop="deptId" width="200" />

      <el-table-column prop="parentName" label="上级部门" show-overflow-tooltip />
      <el-table-column prop="orderNum" label="排序号" width="80" align="center" />
    </el-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      selectRows: []
    }
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList
    })
  },

  created() {
    this.$emit('setCurrentMenu', '部门管理')
    this.getdeptList()
  },

  methods: {
    getdeptList() {
      const vm = this
      vm.axios
        .get(this.homePath() + '/sys/dept/list')
        .then((response) => {
          const data = response.data
          vm.tableData = vm.toTreeData(data, 'parentId', 'deptId')
        })
        .catch((error) => console.log(error))
    },

    add() {
      this.$router.push('/index/adddept')
    },

    revise() {
      const vm = this
      if (vm.selectRows.length < 1) {
        vm.$alert('请选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      if (vm.selectRows.length > 1) {
        vm.$alert('只能选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }
      this.$router.push('/index/revisedept/' + vm.selectRows[0].deptId)
    },

    del() {
      const vm = this

      if (vm.selectRows.length < 1) {
        vm.$alert('请选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      if (vm.selectRows.length > 1) {
        vm.$alert('只能选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })

        return
      }

      if (vm.selectRows[0].parentId == 0) {
        vm.$alert('一级部门不能删除', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      vm.$confirm('确定要删除选中的记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          vm.axios
            .post(vm.homePath() + '/sys/dept/delete/?deptId=' + vm.selectRows[0].deptId)
            .then((response) => {
              if (response.data.status == '000000') {
                vm.$message({
                  type: 'success',
                  message: '删除成功!'
                })

                vm.getdeptList()
              } else {
                console.log(response.data.message)
              }
            })
            .catch((error) => console.log(error))
        })
        .catch(() => {
          vm.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },

    rowClick(row, column, event) {
      const refsElTable = this.$refs.multipleTable
      const findRow = this.selectRows.find((c) => c.rowIndex == row.rowIndex)
      if (findRow) {
        refsElTable.toggleRowSelection(row, false)
        return
      }
      refsElTable.clearSelection()
      refsElTable.toggleRowSelection(row)
    },

    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, 'rowIndex', {
        value: rowIndex,
        writable: true,
        enumerable: false
      })
    },

    rowClassName({ row, rowIndex }) {
      let rowName = ''
      const findRow = this.selectRows.find((c) => c.rowIndex === row.rowIndex)
      if (findRow) {
        rowName = 'current-row '
      }
      return rowName
    },

    selectionChange(rows) {
      this.selectRows = rows
    }
  }
}
</script>

<style></style>
